import { Radio } from '@mantine/core'
import RadioClasses from './styles.module.css'

export default Radio.extend({
    defaultProps: { size: 'md', variant: 'filled' },
    classNames: RadioClasses,
})
